export function renderFooter(): string {
  return `
    <footer class="footer" id="contact">
      <div class="footer-container">
        <div class="footer-brand">
          <div class="brand">
            <span class="brand-shield">🛡️</span>
            <span class="brand-name">TRIBUTE <span class="brand-highlight">DEFENSE</span></span>
          </div>
          <p class="footer-copy">© ${new Date().getFullYear()} Tribute Defense Solutions. All rights reserved.</p>
        </div>
        <div class="footer-status">
          <span class="status-indicator">
            <span class="dot"></span> Systems Operational
          </span>
        </div>
      </div>
    </footer>
  `;
}

